const TIMEOUT = 2000;
export function onClick(parent) {
    const input = parent.querySelector('input');
    if (!navigator.clipboard) {
        if (copyWithSelection(input)) {
            showClicked(parent);
        }
        return;
    }
    navigator.clipboard.writeText(input.value)
        .then(() => showClicked(parent))
        // браузер может запретить запись в буфер обмена (например, Firefox на старых системах) — копируем через выделение
        .catch(() => {
        if (copyWithSelection(input)) {
            showClicked(parent);
        }
    });
}
/**
 * Выделяет текст поля и копирует его; если копирование не удалось, текст остаётся выделенным для ручного копирования
 */
function copyWithSelection(input) {
    input.select();
    try {
        return document.execCommand('copy');
    }
    catch {
        return false;
    }
}
function showClicked(el) {
    el.classList.add('clicked');
    if (el.dataset.timeout) {
        clearTimeout(el.dataset.timeout);
    }
    el.dataset.timeout = setTimeout(() => {
        el.classList.remove('clicked');
        delete el.dataset.timeout;
    }, TIMEOUT).toString();
}
export default function initClickToCopy(selector) {
    document.querySelectorAll(selector)
        .forEach(copyBox => copyBox.addEventListener('click', () => onClick(copyBox)));
}
